.layout {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-left: auto;
  margin-right: auto;
  max-width: calc(var(--page-max-width) + var(--page-margin-desktop) * 2);
  width: 100dvw;
}
